import React, { useEffect, useState } from "react";
import api, { formatErr } from "../../../lib/api";
import { card, label, input, btn, btnGhost, SvgViewer, downloadBlob } from "./_drawingsCommon";

export default function HookUpPanel({ projectId }) {
  const [templates, setTemplates] = useState([]);
  const [template, setTemplate] = useState("LT-DP");
  const [tag, setTag] = useState("LT-101");
  const [line, setLine] = useState("L-100-001-1A1");
  const [drawingNo, setDrawingNo] = useState("");
  const [revision, setRevision] = useState("0");
  const [blobUrl, setBlobUrl] = useState(null);
  const [filename, setFilename] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get(`/projects/${projectId}/hook-ups/templates`)
      .then(({ data }) => setTemplates(data))
      .catch((e) => setErr(formatErr(e?.response?.data?.detail) || String(e)));
  }, [projectId]);

  const generate = async () => {
    setErr(""); setBlobUrl(null); setBusy(true);
    try {
      const { data } = await api.post(`/projects/${projectId}/hook-ups.svg`,
        { template, tag, line, drawing_no: drawingNo || undefined, revision },
        { responseType: "blob" });
      const fn = `hookup-${template}-${tag}-${revision}.svg`;
      setFilename(fn);
      setBlobUrl(URL.createObjectURL(data));
    } catch (e) {
      try {
        const txt = await e?.response?.data?.text?.();
        setErr(formatErr(txt && JSON.parse(txt).detail) || String(e));
      } catch { setErr(formatErr(e?.response?.data?.detail) || String(e)); }
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="hookup-panel" style={{ display: "grid", gridTemplateColumns: "320px 1fr", gap: 12 }}>
      <div style={card}>
        <div style={label}>Hook-Up Template ({templates.length})</div>
        <select style={input} data-testid="hu-template"
          value={template} onChange={(e) => setTemplate(e.target.value)}>
          {templates.map((t) => (
            <option key={t.id} value={t.id}>{t.id} — {t.label}</option>
          ))}
        </select>

        <div style={{ height: 10 }} />
        <div style={label}>Instrument & Line</div>
        <input style={input} data-testid="hu-tag" placeholder="Instrument tag (e.g. LT-101)"
          value={tag} onChange={(e) => setTag(e.target.value)} />
        <div style={{ height: 6 }} />
        <input style={input} data-testid="hu-line" placeholder="Line number"
          value={line} onChange={(e) => setLine(e.target.value)} />

        <div style={{ height: 10 }} />
        <div style={label}>Drawing Meta</div>
        <input style={input} data-testid="hu-drawing-no" placeholder="Drawing No (optional)"
          value={drawingNo} onChange={(e) => setDrawingNo(e.target.value)} />
        <div style={{ height: 6 }} />
        <input style={input} data-testid="hu-revision" placeholder="Revision"
          value={revision} onChange={(e) => setRevision(e.target.value)} />

        <div style={{ height: 10 }} />
        <button style={{ ...btn, width: "100%" }} data-testid="hu-generate" onClick={generate} disabled={busy}>
          {busy ? "Generating…" : "Generate Hook-Up SVG"}
        </button>
        {blobUrl && (
          <button style={{ ...btnGhost, width: "100%", marginTop: 6 }}
            data-testid="hu-download" onClick={() => downloadBlob(blobUrl, filename)}>
            Download {filename}
          </button>
        )}
        {err && <div style={{ marginTop: 8, padding: 8, fontSize: 11, color: "#FF8888", background: "rgba(239,68,68,.1)", borderRadius: 4 }}>{err}</div>}
      </div>

      <SvgViewer blobUrl={blobUrl} testId="hu-svg" emptyText="Pick a template (24 available — DP level, radar, RTD, orifice, mag, control valve, PSV, …) and click Generate." />
    </div>
  );
}
